import React, { Component } from 'react';
import CompanySummary from './CompanySummary';
import Cookies from 'universal-cookie';
import M from 'materialize-css';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';

const cookies = new Cookies();
const refModal = React.createRef();

class CompanyList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentCompanies: [],
      currentCountry: cookies.get('country') || 'ALL',
      selectedCompanyName: '',
      selectedCompanyId: '',
    };
  }

  componentDidMount() {
    this.loadCompaniesByCountry(this.state.currentCountry);
    var elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }

  changeCountry(country) {
    cookies.set('country', country);
    this.setState({
      currentCountry: country,
    });
    this.loadCompaniesByCountry(country);
  }

  loadCompaniesByCountry(country) {
    const { companies } = this.props;

    let currentCompanies = companies.filter((company, index, array) => {
      return country === 'ALL' || company.countryCode === country;
    });

    this.setState({
      currentCompanies: currentCompanies,
    });
  }

  renderCountryFilter() {
    const { currentCountry } = this.state;
    return (
      <div className="country-filter">
        <div className={'country-filter-item ' + (currentCountry === 'ALL' ? 'country-filter-item-selected' : '')}>
          <a href="#all" onClick={(e) => this.changeCountry('ALL')}>
            <img src="images/all.svg" alt="ALL" className="country-image-filter" />
          </a>
        </div>
        <div className={'country-filter-item ' + (currentCountry === 'CA' ? 'country-filter-item-selected' : '')}>
          <a href="#ca" onClick={(e) => this.changeCountry('CA')}>
            <img src="images/ca.svg" alt="CA" className="country-image-filter" />
          </a>
        </div>
        <div className={'country-filter-item ' + (currentCountry === 'US' ? 'country-filter-item-selected' : '')}>
          <a href="#us" onClick={(e) => this.changeCountry('US')}>
            <img src="images/us.svg" alt="US" className="s4 country-image-filter" />
          </a>
        </div>
        <div className={'country-filter-item ' + (currentCountry === 'BO' ? 'country-filter-item-selected' : '')}>
          <a href="#bo" onClick={(e) => this.changeCountry('BO')}>
            <img src="images/bo.svg" alt="BO" className="s4 country-image-filter" />
          </a>
        </div>
      </div>
    );
  }

  deleteSelectedCompany() {
    const { firestore } = this.props;
    firestore
      .collection('companies')
      .doc(this.state.selectedCompanyId)
      .delete()
      .then((response) => {
        console.log('Delete Company completed', response);
        return true;
      })
      .catch((error) => {
        console.warn('Delete Company Failed', error);
        return false;
      });
  }

  renderDeleteDialog() {
    return (
      <div ref={refModal} id="modal1" className="modal">
        <div className="modal-content">
          <h5>Are you sure to delete "{this.state.selectedCompanyName}" company?</h5>
          <p>This action will remove ALL the data related to this company</p>
        </div>
        <div className="modal-footer">
          <a href="#!" onClick={(e) => this.deleteSelectedCompany()} className="modal-close waves-effect btn btn-flat">
            Confirm
          </a>
          <a href="#close" className="modal-close waves-effect btn btn-flat">
            Cancel
          </a>
        </div>
      </div>
    );
  }

  onDelete = (companyId, companyName) => {
    const modal = M.Modal.getInstance(refModal.current);
    this.setState({
      selectedCompanyId: companyId,
      selectedCompanyName: companyName,
    });
    modal.open();
  };

  render() {
    const { currentCompanies } = this.state;
    return (
      <div className="company-list section">
        {this.renderCountryFilter()}
        <div className="title-section">Companies</div>
        {this.renderDeleteDialog()}
        {currentCompanies &&
          currentCompanies.map((company) => {
            if (company.companyName) {
              return <CompanySummary key={company.id} company={company} onDelete={this.onDelete} />;
            } else {
              return <div></div>;
            }
          })}
      </div>
    );
  }
}

export default compose(firestoreConnect())(CompanyList);
